import { render, staticRenderFns } from "./collectionformdetail.vue?vue&type=template&id=1c323c96&scoped=true&"
import script from "./collectionformdetail.vue?vue&type=script&lang=js&"
export * from "./collectionformdetail.vue?vue&type=script&lang=js&"
import style0 from "./collectionformdetail.vue?vue&type=style&index=0&id=1c323c96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c323c96",
  null
  
)

export default component.exports